import React from 'react';
import { navigate, RouteComponentProps } from '@gatsbyjs/reach-router';
import withErrorBoundary from '~/hocs/withErrorBoundary';
import ErrorScreen from '~/components/page/ErrorScreen';
import Catalog from '~/Catalog';
import { WithNavigationFrame as NotFound } from '~/components/page/404';
import DHRouter from '~/components/atom/DHRouter';
import withPermissionCheck from '~/hocs/withPermissionCheck';

import CreateFlowBuilder from './components/CreateFlowBuilder';
import UpdateFlowBuilder from './components/UpdateFlowBuilder';
import FlowList from './components/FlowList';
import ShareFlowSettings from './components/ShareFlowSettings';
import ImportFlow from './components/ImportFlow';

type Props = RouteComponentProps;
const Flows: React.FC<Props> = () => (
  <DHRouter>
    <FlowList path="/" />
    <CreateFlowBuilder path="/builder-v2/create/:token" />
    <UpdateFlowBuilder path="/builder-v2/update/:id" />
    <ShareFlowSettings
      path="/sharing/:id"
      onClose={() => {
        void navigate('/-/automation/flows', {
          state: { noRefetch: true },
        });
      }}
    />
    <ImportFlow
      path="/import"
      onClose={() => {
        void navigate('/-/automation/flows', {
          state: { noRefetch: true },
        });
      }}
    />
    <NotFound default />
  </DHRouter>
);

export default withPermissionCheck(
  withErrorBoundary<Props>(
    Flows,
    <ErrorScreen explanation={Catalog.genericUnknownErrorMessage} />,
  ),
  ['root.automation'],
);
